import React, { useEffect, useState } from "react";
import Moment from "react-moment";

import ImagePreview from "../ImagePreview";
import StickerPreview from "../StickerPreview";
import VideoPreview from "../VideoPreview";

import infoCirclekImg from "../../assets/images/info-circle-red.svg";
import thumpsDownFilled from "../../assets/images/svg/Thumbs-Down-Filled.svg";
import thumpsUpFilled from "../../assets/images/svg/Thumbs-Up-Filled.svg";
import thumbsDownBlue from "../../assets/images/svg/thumb-down-outline-blue.svg";
import thumbsupBlue from "../../assets/images/svg/thumb-up-outline-blue.svg";
import thumbsupOutlined from "../../assets/images/svg/thumbs-down-outline.svg";
import thumbsdownBlueOutlined from "../../assets/images/svg/thumbs-up-outline.svg";
import LoadingAnimation from "../LoadingAnimation";
import "./style.css";
import { authHeader } from "../../helpers/auth-header";
import { getUrlParameter } from "../../utils/formatFunctions";

const BotReply = ({
  replyType,
  references,
  data,
  replyTime,
  replyId,
  bookmarkAction,
  showFeedback,
  feedback,
  recordFeedback,
  documentPreviewSetting,
  setDocumentPreview,
  element,
  defaultDisclaimer,
  html,
}) => {
  const [showFavBar, setShowFavBar] = useState(false);
  const [localFeedback, setLocalFeedback] = useState(null);
  const [isLoadingDocs, setLoadingDocs] = useState(false);
  const [docPreviews, setDocPreviews] = useState([]);
  const [isReferencesShown, setReferencesShown] = useState(false);

  let params = getUrlParameter(
    window.location.search.split("?")[1]
  );

  const isViewSource = data?.reference_highlights ? true : false;

  const generateContent = () => {
    if (docPreviews.length !== 0) {
      setReferencesShown(true);
      return;
    }

    let requestUrl =
      `/api/v1/chatbot/replies/${replyId}/bubbles/${data?.id}/references?agent_id=${params.agent_id}`;
    const requestOptions = {
      method: "GET",
      headers: authHeader(params.t),
    };

    setLoadingDocs(true);
    fetch(window.CHAT_API + requestUrl, requestOptions)
    .then(async (json) => {
      console.log("great", json);
      if (json.status === 200) {
        const { data } = await json.json();
        setReferencesShown(true);
        setDocPreviews(data.references);
      }
      setLoadingDocs(false);
    });
  };

  useEffect(() => {
    // if (feedbackType && feedbackType.hasOwnProperty("type")) {
    setLocalFeedback(feedback);
    // }
  }, [feedback]);

  const getBotReplyItem = () => {
    if (data.template === "text") {
      // text-reply-from-gpt
      return (
        <>
          <div
            className={`
              ${element &&
              element.context &&
              element.context.botmode === "improvising"
                ? "text-reply-container text-reply-from-gpt" +
                  (data.text.length < 55
                    ? " text-reply-from-gpt-low-content"
                    : "")
                : "text-reply-container"}
              ${isViewSource && docPreviews.length !== 0 ? "view-source" : ""}
            `}
            onClick={() => {
              setShowFavBar(!showFavBar);
            }}
          >
            <div
              className="text-reply text-reply-list"
              dangerouslySetInnerHTML={{ __html: data.html }}
            ></div>

            {element &&
              element.context &&
              element.context.botmode === "improvising" && (
                <div
                  className="chatInfo-toltip position-relative"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <button className="btn px-2">
                    <img src={infoCirclekImg} alt="" />
                  </button>
                  <div className="toltip-description">{defaultDisclaimer}</div>
                </div>
              )}

            {showFeedback && showFavBar && (
              <>
                <div className="bot-reply-feedback-container">
                  <span
                    className={`bot-reply-feedback-icon${
                      localFeedback === 1
                        ? " bot-reply-feedback-icon-selected"
                        : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      recordFeedback(1, replyId);
                    }}
                  >
                    <button className="btn">
                      <img
                        src={
                          localFeedback === 1 ? thumpsUpFilled : thumbsupBlue
                        }
                        alt=""
                      />
                    </button>
                  </span>
                  <span
                    className={`bot-reply-feedback-icon${
                      localFeedback === 0
                        ? " bot-reply-feedback-icon-selected"
                        : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      recordFeedback(0, replyId);
                    }}
                  >
                    <button className="btn">
                      <img
                        src={
                          localFeedback === 0
                            ? thumpsDownFilled
                            : thumbsDownBlue
                        }
                        alt=""
                      />
                    </button>
                  </span>
                </div>
              </>
            )}
          </div>
        </>
      );
    } else if (data.template === "image" && data.image) {
      return <ImagePreview src={data.image.url} altText={data.text} />;
    } else if (data.template === "image" && !data.image) {
      return <ImagePreview html={data.html} altText={data.text} />;
    } else if (data.template === "video") {
      return <VideoPreview link={data.video.url} html={data.html} />;
    } else if (data.template === "sticker") {
      return <StickerPreview src={data.image.url} altText={"sticker"} />;
    }
  };

  if (replyType === "loading") {
    return (
      <div className="loading-bubble">
        <LoadingAnimation />
      </div>
    );
  }

  return (
    <div className="bot-reply-wrapper">
      <div className="flex-container">
        <div
          className={
            element &&
            element.context &&
            element.context.botmode === "improvising"
              ? "bot-reply-container bot-reply-container-from-gpt"
              : "bot-reply-container"
          }
        >
          {getBotReplyItem()}
          
          {isReferencesShown && docPreviews.length > 0 && <div className="reference-container">
            <div>References: </div>
            {
              docPreviews.map((doc, index) => <div className="doc-item">
                <span className="mr-1">{index + 1}.</span>
                <button onClick={() => {
                  setDocumentPreview(doc, replyId, docPreviews)
                }}>{doc.name}</button>
              </div>)
            }
          </div>}

          {isViewSource && !isReferencesShown && (
            <div
              className="bot-document-preview-button d-flex align-items-center"
              onClick={() => { generateContent() }}
            >
              {isLoadingDocs && <span className="reference-loader"></span>}
              View References
            </div>
          )}
          {isViewSource && isReferencesShown && (
            <div
              className="bot-document-preview-button d-flex align-items-center"
              onClick={() => { setReferencesShown(false) }}
            >
              Hide References
            </div>
          )}
        </div>
      </div>
      <div className="bot-reply-time">
        <Moment format="DD/MM/YYYY HH:mm" utc local>
          {new Date()}
        </Moment>
      </div>
    </div>
  );
};

export default BotReply;
